export default __webpack_public_path__ + "static/media/planet2.1437d625.webp";